import Splide from '@splidejs/splide';

export default class HeroBusiness {
    constructor(element) {
        this.element = element;
        this.slider = this.element.querySelector('.splide');
        
        this.init();
    }

    init() {
        if (this.slider) {

			const interval = this.element.dataset.interval ? this.element.dataset.interval : 12000;

			new Splide(this.slider, {
				type: 'fade',
				rewind: true,
				perPage: 1,
				drag: 'true',
				perMove: 1,
				padding: 0,
				pagination: false,
				arrows: true,
				autoplay: true,
				interval: interval,
				speed: 1500,
				transition: 'css',
				waitForTransition: true,
				pauseOnHover: true,
				updateOnMove: true,
				video: {
					loop: true,
					muted: true,
					autoplay: true,
					hideControls: true,
					height: '100%',
				},
				intersection: {
					inView: {
						autoplay: true,
					},
					outView: {
						autoplay: false,
					},
				},
				classes: {
                    arrows: 'hero-business__navigation',
                    arrow: 'hero-business__arrow',
                    prev: 'hero-business__prev',
                    next: 'hero-business__next',
                },
			}).mount({
			})
        }
    }
} 